module.exports = __webpack_public_path__ + "static/media/uTurnRight.7b46f7e7.svg";